// Shadow definitions for elevation system
export const shadows = {
  none: 'none',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
};

// Dark mode shadow variants
export const darkShadows = {
  none: 'none',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
  base: '0 1px 3px 0 rgba(0, 0, 0, 0.4), 0 1px 2px 0 rgba(0, 0, 0, 0.3)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -1px rgba(0, 0, 0, 0.3)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -2px rgba(0, 0, 0, 0.3)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.4), 0 10px 10px -5px rgba(0, 0, 0, 0.3)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.3)',
};

// Shadow utility functions
export const getShadow = (level, theme = 'light') => {
  return theme === 'dark' ? darkShadows[level] : shadows[level];
};

// CSS custom properties for shadows
export const generateShadowCSSVariables = (theme = 'light') => {
  const shadowSet = theme === 'dark' ? darkShadows : shadows;
  const variables = {};
  
  Object.entries(shadowSet).forEach(([key, value]) => {
    variables[`--shadow-${key}`] = value;
  });
  
  return variables;
};

// Elevation levels for consistent UI hierarchy
export const elevation = {
  level0: 'none',           // No elevation (flat elements)
  level1: shadows.sm,       // Subtle elevation (cards, buttons)
  level2: shadows.md,       // Medium elevation (modals, dropdowns)
  level3: shadows.lg,      // High elevation (popovers, tooltips)
  level4: shadows.xl,      // Maximum elevation (overlays)
};

export const getElevation = (level, theme = 'light') => {
  const shadowLevel = elevation[level];
  return getShadow(shadowLevel, theme);
};

export default shadows;
